import {
  Flex,
  View,
  ViewProps,
  Button,
  ActionButton,
  Heading,
} from "@adobe/react-spectrum";
import { FC } from "react";
import { googleLogout } from "@react-oauth/google";
import { useDispatch, useSelector } from "react-redux";
import { selectAccessToken, setLogout } from "store/slices/credentials";
import { logoutSpreadsheet } from "store/slices/spreadsheet";
import { logoutQuestions } from "store/slices/questions";
import { useNavigate } from "react-router";

export const Header: FC<ViewProps<6>> = (props) => {
  const dispatch = useDispatch();
  const accessToken = useSelector(selectAccessToken);
  const navigate = useNavigate();

  return (
    <View
      {...props}
      backgroundColor="gray-200"
      paddingStart="size-200"
      paddingEnd="size-200"
    >
      <Flex justifyContent="space-between">
        <Flex direction="column" justifyContent="space-around">
          <Heading>BOB Quizzer</Heading>
        </Flex>

        <Flex direction="column" justifyContent="space-around">
          {accessToken && (
            <ActionButton
              onPress={() => {
                googleLogout();
                dispatch(setLogout());
                dispatch(logoutSpreadsheet());
                dispatch(logoutQuestions());
              }}
            >
              Logout
            </ActionButton>
          )}

          {!accessToken && (
            <ActionButton
              onPress={() => {
                navigate("/login");
              }}
            >
              Login
            </ActionButton>
          )}
        </Flex>
      </Flex>
    </View>
  );
};
